import React from 'react';

const SectionAmount = ({
  targetAmount,
  setTargetAmount,
  limitAmount,
  setLimitAmount,
  limitError,
  setLimitError,
}) => {
  return (
    <section id="crafan_amount">
      <div className="container col-md-8 col-lg-6">
        <div style={{ display: 'flex' }}>
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
            プロジェクトの目標および上限金額
          </p>
        </div>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 border-bottom p-3_5">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">目標金額</p>
            <div className="col-8 d-flex justify-content-end">
              <input
                id="price"
                className="p-0 textarea--eventreport text-right"
                type="number"
                min="0"
                onChange={e => setTargetAmount(e.target.value)}
                value={targetAmount}
                placeholder="必須"
                style={{ width: '160px' }}
              />
              <span className="p-0 text-right">円</span>
            </div>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6 border-bottom p-3_5">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">募集上限金額</p>
            <div className="col-8 d-flex justify-content-end">
              <input
                id="price"
                className={`p-0 textarea--eventreport text-right form-control ${limitError ? 'is-invalid' : ''}`}
                type="number"
                value={limitAmount}
                min="0"
                onChange={e => {
                  setLimitAmount(e.target.value);
                  setLimitError(!e.target.value.trim());
                }}
                placeholder="必須"
                style={{ width: '160px' }}
              />
              <span className="p-0 text-right">円</span>
              {limitError && (
                <div className="invalid-feedback">この項目は必須入力です。</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionAmount;
